import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';

const initialState = {
  loading: false,
  data: [],
  leadDetails: {},
  leadDetailsLoading: false,
  cartItems: [],
  leadPreferance: {},
  nextPaymentLink: {},
  cartStudents: [],
  emiCartItems: [],
  classroomRange: [],
  holdAmountData: [],
  cartEditData: [],
  availableBatchList: [],
  CartItemsSkillx: [],
  categories: [],
};

export const createCartItem = createAsyncThunk('cart/createCartItem', async (data) => {
  const res = await apiRequest({
    url: `cart/add-items`,
    method: 'post',
    data: data,
  });
  return res;
});
export const getLeadDetails = createAsyncThunk('cart/getLeadDetails', async (id) => {
  const res = await apiRequest({
    url: `lead/getLead/${id}`,
    method: 'get',
  });
  return res;
});

export const getCartItems = createAsyncThunk('cart/getCartItems', async (id) => {
  const res = await apiRequest({
    url: `cart/get-cart/${id}?limit=no`,
    method: 'get',
  });
  return res;
});

// Read-only preview of an AED -> INR conversion for one enrolled cart item.
export const getConvertToInrPreview = createAsyncThunk('cart/getConvertToInrPreview', async (cartId) => {
  const res = await apiRequest({
    url: `cart/convert-to-inr/${cartId}/preview`,
    method: 'get',
  });
  return res;
});

// Commit the AED -> INR conversion. Pass { cartId, rate, admissionFee } (both
// optional — the backend derives the rate from the first payment and the
// admission fee from rate * AED admission fee when omitted).
export const convertCartToInr = createAsyncThunk('cart/convertCartToInr', async ({ cartId, rate, admissionFee }) => {
  const data = {};
  if (rate !== '' && rate !== null && rate !== undefined) data.rate = rate;
  if (admissionFee !== '' && admissionFee !== null && admissionFee !== undefined) data.admissionFee = admissionFee;
  const res = await apiRequest({
    url: `cart/convert-to-inr/${cartId}`,
    method: 'post',
    data,
  });
  return res;
});
export const UpdateCartItems = createAsyncThunk('cart/UpdateCartItems', async (data) => {
  const res = await apiRequest({
    url: `cart/patch-items`,
    method: 'patch',
    data: data,
  });
  return res;
});
export const deleteCart = createAsyncThunk('cart/deleteCart', async (id) => {
  const res = await apiRequest({
    url: `cart/delete-items/${id}`,
    method: 'delete',
  });
  return res;
});

export const getleadPreferance = createAsyncThunk('ogd/getleadPreferance', async (id) => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/leadPreferance/${id}`,
  });
  return res;
});
export const makeNextPayment = createAsyncThunk('ogd/makeNextPayment', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `cart/next-payment`,
    data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  });
  return res;
});

export const deletePaymentLog = createAsyncThunk('ogd/deletePaymentLog', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `cart/delete-payment/${id}`,
  });
  return res;
});

export const getCartStudents = createAsyncThunk('ogd/getCartStudents', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/cart-admissions?limit=no`,
  });
  return res;
});
export const getEmiCartItem = createAsyncThunk('ogd/getEmiCartItem', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/finance/${data.id}?page=${data.page}&limit=${data.limit}`,
  });
  return res;
});
export const deleteSubject = createAsyncThunk('ogd/deleteSubject', async (data) => {
  const res = await apiRequest({
    method: 'delete',
    url: `cart/subject/${data.cartId}/${data.subjectId}`,
  });
  return res;
});
export const getClassroomRange = createAsyncThunk('cart/getClassroomRange', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/class-room-range`,
  });
  return res;
});
export const postHoldAmt = createAsyncThunk('cart/postHoldAmt', async (data) => {
  const holdings = data.holdings.map((item) => {
    const { paymentProof, ...rest } = item;
    return rest;
  });

  const res = await apiRequest({
    method: 'post',
    url: `cart/holdAmt/${data.cartItemId}`,
    data: holdings,
  });
  return res;
});
export const getHoldAmt = createAsyncThunk('cart/getHoldAmt', async (cartItemId) => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/holdAmt/${cartItemId}?limit=no`,
  });
  return res;
});

export const deleteHoldAmt = createAsyncThunk('cart/deleteHoldAmt', async (id) => {
  const res = await apiRequest({
    method: 'delete',
    url: `cart/holdAmt/${id}`,
  });
  return res;
});

export const getCartEditPreData = createAsyncThunk('cart/getCartEditPreData', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `cart/edit/${data.enrollId}?requestId=${data.reqId}`,
  });
  return res;
});
export const UpdateCartData = createAsyncThunk('cart/UpdateCartData', async (data) => {
  const res = await apiRequest({
    method: 'patch',
    url: `cart/edit/${data.enrollId}/${data.reqId}`,
    data: data,
  });
  return res;
});

export const getAvailableBatch = createAsyncThunk('cart/getAvailableBatch', async (courseId) => {
  const res = await apiRequest({
    method: 'get',
    url: `batch-management/get-available-batches/${courseId}`,
  });
  return res;
});

export const downloadReciept = createAsyncThunk('cart/downloadReciept', async (id) => {
  const res = await apiRequest({
    method: 'put',
    url: `cart/download-status/${id}`,
  });
  return res;
});

// ------------------------skillx-------------------------------
export const getCartItemsSkillx = createAsyncThunk('cart/getCartItemsSkillx', async (id) => {
  const res = await apiRequest({
    url: `cart/skillx/get-cart/${id}?limit=no`,
    method: 'get',
  });
  return res;
});

export const getCourseCategories = createAsyncThunk('cart/getCourseCategories', async (id) => {
  const res = await apiRequest({
    url: `/general/get-course-category`,
    method: 'get',
  });
  return res;
});

export const deleteCourse = createAsyncThunk('cart/deleteCourse', async (cartId) => {
  const res = await apiRequest({
    method: 'delete',
    url: `cart/delete/${cartId}`,
  });
  return res;
});

export const bulkNextPayment = createAsyncThunk('cart/bulkNextPayment', async (data) => {
  const res = await apiRequest({
    method: 'put',
    url: `cart/bulk-payment`,
    data: data,
  });
  return res;
});
const cartSlice = createSlice({
  name: 'cartSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //.................createCartItem..............................
    builder.addCase(createCartItem.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(createCartItem.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------getLeadDetails-----------------------------
    builder.addCase(getLeadDetails.pending, (state, action) => {
      return {
        ...state,
        leadDetailsLoading: true,
      };
    });
    builder.addCase(getLeadDetails.fulfilled, (state, action) => {
      return {
        ...state,
        leadDetails: action.payload.data,
        leadDetailsLoading: false,
      };
    });
    // --------------------getCartItems----------------------------
    builder.addCase(getCartItems.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCartItems.fulfilled, (state, action) => {
      return {
        ...state,
        cartItems: action.payload.data,
        loading: false,
      };
    });
    // --------------------UpdateCartItems---------------------------
    builder.addCase(UpdateCartItems.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(UpdateCartItems.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -----------------deleteCart---------------------------------
    builder.addCase(deleteCart.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteCart.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------------------------
    builder.addCase(getleadPreferance.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getleadPreferance.fulfilled, (state, action) => {
      return {
        ...state,
        leadPreferance: action.payload.data,
        loading: false,
      };
    });
    // --------------------makeNextPayment------------------------------
    builder.addCase(makeNextPayment.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(makeNextPayment.fulfilled, (state, action) => {
      return {
        ...state,
        nextPaymentLink: action.payload.data,
        loading: false,
      };
    });
    // --------------------deletePaymentLog-----------------------
    builder.addCase(deletePaymentLog.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deletePaymentLog.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------getCartStudents----------------------------

    builder.addCase(getCartStudents.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCartStudents.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        cartStudents: data,
        loading: false,
      };
    });
    // ---------------------getEmiCartItem--------------------------
    builder.addCase(getEmiCartItem.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getEmiCartItem.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        emiCartItems: data,
        loading: false,
      };
    });
    // ---------------------deleteSubject------------------------
    builder.addCase(deleteSubject.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteSubject.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ------------------------getClassroomRange--------------------------
    builder.addCase(getClassroomRange.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getClassroomRange.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        classroomRange: data,
        loading: false,
      };
    });
    // -------------postHoldAmt------------------------------------
    builder.addCase(postHoldAmt.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(postHoldAmt.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------getHoldAmt-----------------------------------

    builder.addCase(getHoldAmt.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getHoldAmt.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        holdAmountData: data,
        loading: false,
      };
    });
    // ----------------------deleteHoldAmt-----------------------------------
    builder.addCase(deleteHoldAmt.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteHoldAmt.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------getCartEditPreData--------------------------------------------
    builder.addCase(getCartEditPreData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCartEditPreData.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        cartEditData: data,
        loading: false,
      };
    });
    // --------------UpdateCartData-----------------------------
    builder.addCase(UpdateCartData.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(UpdateCartData.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------------getAvailableBatch-------------------------
    builder.addCase(getAvailableBatch.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAvailableBatch.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        loading: false,
        availableBatchList: data,
      };
    });
    // ----------------------getCartItemsSkillx---------------------

    builder.addCase(getCartItemsSkillx.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCartItemsSkillx.fulfilled, (state, action) => {
      const data = action.payload.data;
      return {
        ...state,
        loading: false,
        cartItems: data,
      };
    });
    // --------------------downloadReciept-------------------------
    builder.addCase(downloadReciept.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(downloadReciept.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ---------------------getCourseCategories--------------------------

    builder.addCase(getCourseCategories.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getCourseCategories.fulfilled, (state, action) => {
      return {
        ...state,
        categories: action.payload.data,
        loading: false,
      };
    });

    // ---------------------deltecourse through cartId--------------------------

    builder.addCase(deleteCourse.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(deleteCourse.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // ----------------------bulkNextPayment--------------------------
    builder.addCase(bulkNextPayment.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(bulkNextPayment.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
  },
});

export default cartSlice.reducer;
